// extracted by mini-css-extract-plugin
export default {"inputContainer":"Input_inputContainer__-5ehW","submitButton":"Input_submitButton__g65bd"};